module.exports = __webpack_public_path__ + "img/fill.0bc590b4.png";